/**
 * Converts duration in MM or MM.SS format to HH:MM:SS
 *
 * Rules:
 *  - 4        -> 00:04:00
 *  - 5        -> 00:05:00
 *  - 4.5      -> 00:04:05
 *  - 34.03    -> 00:34:03
 */
export const formatDurationHHMMSS = (
  value?: number | string
): string => {
  if (value === null || value === undefined || value === "") {
    return "00:00:00";
  }

  const stringValue = String(value);

  let minutes = 0;
  let seconds = 0;

  if (stringValue.includes(".")) {
    const [minPart, secPart] = stringValue?.split(".");
    minutes = Number(minPart) || 0;
    seconds = Number((secPart || "0").padEnd(2, "0")) || 0;
  } else {
    minutes = Number(stringValue) || 0;
    seconds = 0;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return [hours, remainingMinutes, seconds]
    .map((v) => String(v).padStart(2, "0"))
    .join(":");
};
